import _taggedTemplateLiteral from "/home/runner/work/is-eth-congested-website/is-eth-congested-website/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject;

import React from 'react';
import styled from 'styled-components';
import { OutlinedInput } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
var useStyles = makeStyles(function () {
  return {
    input: {
      padding: '10px 14px'
    }
  };
});

var Input = function Input(props) {
  var classes = useStyles();
  return React.createElement(OutlinedInput, Object.assign({
    classes: classes,
    type: "email"
  }, props));
};

Input.displayName = 'Newsletter.Input';
var InputExtra = styled(Input)(_templateObject || (_templateObject = _taggedTemplateLiteral([""])));
export default InputExtra;